var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocalFlavor = function SvgLocalFlavor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 21-3-3.4H7c-.796 0-1.559-.358-2.121-.996C4.316 15.967 4 15.102 4 14.2V7.4c0-.902.316-1.767.879-2.404C5.44 4.358 6.204 4 7 4h10c.796 0 1.559.358 2.121.996.563.637.879 1.502.879 2.404v6.8c0 .902-.316 1.767-.879 2.404-.562.638-1.325.996-2.121.996h-2L12 21Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.5 12 7l1.5 2.5L16 11l-2.5 1.5L12 15l-1.5-2.5L8 11l2.5-1.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLocalFlavor;